import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import { saveAs } from "file-saver";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/brands`;

const BrandDetails = () => {
    const [brands, setBrands] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [errors, setErrors] = useState({});
    const WithEditPermission = withPermission(({ children }) => children, ['brand-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['brand-delete']);
    const WithCreatePermission = withPermission(({ children }) => children, ['brand-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchBrands(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchBrands = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setBrands(response.data.brand.data);
            setPageCount(response.data.brand.last_page);
            setCurrentPage(response.data.brand.current_page);


        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const handleAddBrand = () => {
        setFormData({ name: '' });
        setIsEdit(false);
        setSelectedBrand(null);
        setShowModal(true);
        setErrors({});

    };

    const handleEditBrand = (brand) => {
        setFormData({
            ...brand,

            status: brand.status ? 'active' : 'inactive',  // Map boolean status to string
        });
        setIsEdit(true);
        setSelectedBrand(brand);
        setShowModal(true);
        setErrors({});

    };


    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setBrands(brands.filter(brand => brand.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The brand has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting brand:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete brand. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    // const handleInputChange = (e) => {
    //     const { name, value} = e.target;

    //     // Ensure that we handle the radio button correctly
    //     if (name === "status") {
    //         setFormData((prev) => ({
    //             ...prev,
    //             status: value,
    //         }));
    //     } 
    //     setErrors((prevErrors) => ({
    //         ...prevErrors,
    //         [name]: undefined,
    //     }));
    // };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update the form state
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const getAccountStatusBadge = (status) => {
        if (status === true) {
            return <span className="badge badge-pill badge-soft-success font-size-12 text-success">Active</span>;
        } else if (status === false) {
            return <span className="badge badge-pill badge-soft-warning font-size-12 text-danger">Inactive</span>;
        }
        return <span className="badge badge-pill badge-soft-secondary font-size-12">Unknown</span>;
    };


    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchBrands(newPage);
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';




        return newErrors;
    };
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedBrand.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setBrands(brands.map(ind => (ind.id === selectedBrand.id ? response.data.brand : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setBrands([...brands, response.data.brand]);
            }
            setShowModal(false);
        } catch (error) {
            {
                console.error('Unexpected error: ', error);
            }
        }
    };

    const filteredBrands = brands.filter(brand => !brand.parent_id);
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    const handleBrandExport = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/brands/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "brands.xlsx");
            Toast.fire({ icon: "success", title: "Exported successfully!" });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({ icon: "error", title: "Export failed!" });
        }
    };

    const handleBrandImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/brands/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({ icon: "success", title: "Imported successfully!" });
            setTimeout(() => window.location.reload(), 1000);
            e.target.value = "";

        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.response?.data?.error || "Import failed! Please check your file.",
            });
            e.target.value = "";

        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Brand</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {/* <li className="breadcrumb-item"><a href="javascript:void(0);">Brand</a></li> */}
                                        {/* <li className="breadcrumb-item active">Brand List</li> */}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>

                                        {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddBrand} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add Brand"
                                            >
                                                <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                            </button>
                                        </WithCreatePermission> */}
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleBrandExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export Leads to Excel"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleBrandImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import Leads from Excel"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                            {/* Add Lead Button */}
                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleAddBrand()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Lead"
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Name</th>
                                                <th className="align-middle"> Description</th>
                                                <th className="align-middle"> Status</th>


                                                <th className="align-middle">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(brands) && brands.length > 0 ? (
                                                brands.map((brand, index) => (
                                                    <tr key={brand.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instanceCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`instanceCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td>{brand.name}</td>
                                                        <td>{brand.description}</td>
                                                        <td>{getAccountStatusBadge(brand.status)}</td>
                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li><WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditBrand(brand)}>
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(brand.id)}>
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No brands found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit Brand */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{ width: '480px' }}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit Brand' : 'Add Brand'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="brandName" className="mb-3">
                                                    <Form.Label style={{ fontSize: '13px' }}>Name</Form.Label>
                                                    <Form.Control type="text" name="name" style={{ fontSize: '13px' }} value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}

                                                </Form.Group>

                                                <Form.Group className="mb-4">
                                                    <Form.Label style={{ fontSize: '13px' }}>Description</Form.Label>
                                                    <Form.Control style={{ fontSize: '13px' }}
                                                        as="textarea"
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                <Form.Group controlId="brandStatus" className="mb-4">
                                                    <div>
                                                        <label style={{ fontSize: '13px' }}>
                                                            <input style={{ width: '15px', height: '15px' }}
                                                                type="radio"
                                                                name="status"
                                                                value="active"
                                                                checked={formData.status === 'active'}
                                                                onChange={handleInputChange}
                                                            />&nbsp;
                                                            Active
                                                        </label>
                                                        <label style={{ fontSize: '13px' }}>&nbsp;&nbsp;
                                                            <input style={{ width: '15px', height: '15px' }}
                                                                type="radio"
                                                                name="status"
                                                                value="inactive"
                                                                checked={formData.status === 'inactive'}
                                                                onChange={handleInputChange}
                                                            />&nbsp;
                                                            Inactive

                                                        </label>
                                                    </div>
                                                </Form.Group><br />






                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="secondary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandDetails;

